import { makeStyles } from '@material-ui/styles'

export const useConsolidationStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
  },
  title: {
    lineHeight: 1,
    fontWeight: 700,
    color: theme.palette.wallet.titleColor,
    fontSize: theme.typography.pxToRem(16),
  },
  listContainer: {
    display: 'flex',
    gap: theme.spacing(2.75),
  },
  consolidationContainer: {
    minWidth: 250,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    justifyContent: 'center',
    padding: theme.spacing(2.5),
    margin: theme.spacing(0.5, 0.1),
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.wallet.latestMovements.borderBottom}`,
  },
  statusContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  symbol: {
    float: 'inline-start',
    marginRight: theme.spacing(1.25),
    fontSize: theme.typography.pxToRem(14),
  },
  amount: {
    lineHeight: 1,
    fontWeight: 600,
    textWrap: 'nowrap',
    fontSize: theme.typography.pxToRem(20),
    color: theme.palette.wallet.consolidation.amountColor,
  },
  status: {
    lineHeight: 1,
    fontWeight: 700,
    textWrap: 'nowrap',
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.wallet.consolidation.statusColor,
  },
  consolidationLabel: {
    lineHeight: 1,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.wallet.consolidation.textColor,
  },
  chip: {
    flex: 0,
    width: 'fit-content',
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.spacing(0.5),
    backgroundColor: theme.palette.wallet.chip.color,
    '& .MuiChip-label': {
      padding: 0,
      lineHeight: 1,
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.wallet.chip.textColor,
    },
  },
}))
